import axios from "axios";
import { Cookies } from "react-cookie";

const cookies = new Cookies();
const token = cookies.get("JWTcookie");
const baseURL = process.env.REACT_APP_BASE_URL +`/api`
// baseURL: "https://busy-erin-raven-vest.cyclic.app/api",
const instance = axios.create({
  baseURL:baseURL,
  timeout: 100000,
  headers: { Authorization: "Bearer " + token },
});
// https://officejeeves.com

// const baseUrl=""
export const getReq = async (path) => {
  try {
    const response = await instance.get(`/${path}`);
    const data = response.data;
    return data;
  } catch (error) {
    console.warn(error);
  }
};

export const getReqResponse = async (path) => {
  try {
    const response = await instance.get(`/${path}`);
    return response.data;
  } catch (error) {
    console.warn(error);
    throw error;
  }
};

export const postReq = async (path, body) => {
  try {
    const response = await instance.post(`/${path}`, body);
    const data = response.data;
    return data;
  } catch (error) {
    console.warn(error);
  }
};
export const postReqWithResponse = async (path, body) => {
  try {
    const response = await instance.post(`/${path}`, body).then((res) => res).catch((err) => err);
    return response;
  } catch (error) {
    console.warn(error);
  }
};

export const delReq = async (path, param) => {
  try {
    const response = await instance.delete(`/${path}/${param}`);
    const data = response.data;
    return data;
  } catch (error) {
    console.warn(error);
  }
};

export const patchReq = async (path, body, id) => {
  try {
    const response = await instance.patch(`/${path}/${id}`, body);
    const data = response.data;
    return data;
  } catch (error) {
    console.warn(error);
  }
};

export const putReq = async (path, body, id) => {
  try {
    const response = await instance.put(`/${path}/${id}`, body);
    const data = response.data;
    return data;
  } catch (error) {
    console.warn(error);
  }
};
